var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignalCellularLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_7641)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.33333H16.25V16.6667H13.75V3.33333ZM3.75 11.6667H6.25V16.6667H3.75V11.6667ZM8.75 7.49999H11.25V16.6667H8.75V7.49999Z",
    fill: "#2ECC71"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_811_7641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.33333H16.25V16.6667H13.75V3.33333ZM3.75 11.6667H6.25V16.6667H3.75V11.6667ZM8.75 7.49999H11.25V16.6667H8.75V7.49999Z",
    fill: "#2ECC71"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_811_7641)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 11,
    height: 17,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_7641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalCellularLow);
export default __webpack_public_path__ + "static/media/signal-cellular-low.88d73a3f0a5d48c4f33a1cbf003c37bc.svg";
export { ForwardRef as ReactComponent };